"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    Collapse: function() {
        return _Collapse.Collapse;
    },
    CollapseExaggerated: function() {
        return _Collapse.CollapseExaggerated;
    },
    CollapseSnappy: function() {
        return _Collapse.CollapseSnappy;
    },
    Fade: function() {
        return _Fade.Fade;
    },
    FadeExaggerated: function() {
        return _Fade.FadeExaggerated;
    },
    FadeSnappy: function() {
        return _Fade.FadeSnappy;
    },
    Scale: function() {
        return _Scale.Scale;
    },
    ScaleExaggerated: function() {
        return _Scale.ScaleExaggerated;
    },
    ScaleSnappy: function() {
        return _Scale.ScaleSnappy;
    }
});
const _Collapse = require("./components/Collapse");
const _Fade = require("./components/Fade");
const _Scale = require("./components/Scale");
